export const REVISIA_AUTH_REDIRECT_URL = 'https://revisia.bonuz.it/auth/bonuz/redirect'

const ALLOWED_EXTENSIONS = ['pdf', 'doc', 'docx']

const normalizeExtension = (extension) => {
  if (!extension) return ''
  return String(extension).replace(/^\./, '').toLowerCase()
}

/**
 * Último anexo enviado pelo advogado (sender !== 'client') em PDF/DOC/DOCX.
 */
export const getLastLawyerChatAttachment = (messages = []) => {
  if (!Array.isArray(messages) || messages.length === 0) {
    return null
  }

  const sorted = [...messages].sort((a, b) => {
    const aTime = a.createdAt || a.created_at || 0
    const bTime = b.createdAt || b.created_at || 0
    return bTime - aTime
  })

  for (const message of sorted) {
    if (!message || message.sender === 'client') continue
    if (!Array.isArray(message.files) || message.files.length === 0) continue

    for (let i = message.files.length - 1; i >= 0; i -= 1) {
      const file = message.files[i]
      if (!file) continue

      const extension = normalizeExtension(file.extension)
      if (!ALLOWED_EXTENSIONS.includes(extension)) continue

      return {
        name: file.name,
        extension,
        fileURL: file.fileURL || null
      }
    }
  }

  return null
}
